var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCentralAfricanRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1280)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_1280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V40H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V10H0V0Z",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 20.0002L60 30.0002V40.0002H0V30.0002L30 20.0002ZM10 0.929688L12.645 9.07069L5.72 4.03919H14.28L7.355 9.07069L10 0.929688Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20H60V30H0V20Z",
    fill: "#289728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 0H35V40H25V0Z",
    fill: "#D21034"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_1280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralAfricanRepublic);
export default __webpack_public_path__ + "static/media/central_african_republic.53c83eb2d2b04a5c40f6291d9e9cced0.svg";
export { ForwardRef as ReactComponent };